var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLinkedinFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Social Media / Fill / Linkedin",
    clipPath: "url(#clip0_32575_51746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M16 0.5C16.5304 0.5 17.0391 0.710714 17.4142 1.08579C17.7893 1.46086 18 1.96957 18 2.5V16.5C18 17.0304 17.7893 17.5391 17.4142 17.9142C17.0391 18.2893 16.5304 18.5 16 18.5H2C1.46957 18.5 0.960859 18.2893 0.585786 17.9142C0.210714 17.5391 0 17.0304 0 16.5V2.5C0 1.96957 0.210714 1.46086 0.585786 1.08579C0.960859 0.710714 1.46957 0.5 2 0.5H16ZM15.5 16V10.7C15.5 9.83539 15.1565 9.0062 14.5452 8.39483C13.9338 7.78346 13.1046 7.44 12.24 7.44C11.39 7.44 10.4 7.96 9.92 8.74V7.63H7.13V16H9.92V11.07C9.92 10.3 10.54 9.67 11.31 9.67C11.6813 9.67 12.0374 9.8175 12.2999 10.0801C12.5625 10.3426 12.71 10.6987 12.71 11.07V16H15.5ZM3.88 6.06C4.32556 6.06 4.75288 5.883 5.06794 5.56794C5.383 5.25288 5.56 4.82556 5.56 4.38C5.56 3.45 4.81 2.69 3.88 2.69C3.43178 2.69 3.00193 2.86805 2.68499 3.18499C2.36805 3.50193 2.19 3.93178 2.19 4.38C2.19 5.31 2.95 6.06 3.88 6.06ZM5.27 16V7.63H2.5V16H5.27Z",
    fill: "var(--white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32575_51746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "var(--white)",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFilled);
export default __webpack_public_path__ + "static/media/linkedinFilled.70d73f23bf295aabce62b4cbd54b5a84.svg";
export { ForwardRef as ReactComponent };